import styled from 'styled-components/macro';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

import { chatUI } from 'styles/featureColors/chatUIColors';
import * as colors from 'components/common/colorConstants';

export const Toolbar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;

  padding-right: 16px;
  height: 26px;

  background-color: ${chatUI.toolbar.background};
  border-bottom: ${`0.5px solid ${chatUI.toolbar.border}`};
  color: ${chatUI.toolbar.text};
`;

// use this for short messages like an ID, it shrinks to the exact width of the text
export const ChatUIToolTip = styled(Tippy)`
  padding: 5;
  margin-left: 8px;
  font-size: 8px;
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 500;
  background: ${colors.darkGray2};
  text-align: center;
  &[data-placement^='bottom'] {
    .tippy-arrow {
      border-top-color: ${colors.darkGray2};
    }
  }

  &:hover {
    cursor: pointer;
  }
`;

// use this for paragrphs, it won't inifinitely grow horizontally
export const ChatUIToolTipFixedWidth = styled(ChatUIToolTip)`
  width: 175px;
  margin-left: 2px;
`;

/** *** TOOLBAR RIGHT SIDE *****/

export const ToolbarRight = styled.div`
  display: flex;
  align-items: center;
`;

export const ToolbarTooltip = styled.div`
  display: flex;
  align-items: center;

  p {
    font: normal 400 10px/16px Roboto;

    margin: 0;
  }
`;

export const TooltipText = styled.p`
  font: normal 400 10px/16px Roboto;

  margin: 0;
`;

export const TooltipIcon = styled.img`
  margin: 0;
  padding-left: 5px;
`;

export const ToolbarToggle = styled.img`
  margin: 0;
  padding-left: 16px;
  cursor: pointer;
`;

/** *** TOOLBAR LEFT SIDE *****/

export const ToolbarLeft = styled.div`
  display: flex;
  align-items: center;
`;

export const ToolbarIconWrapper = styled.div`
  display: flex;
`;
